export const AT_SET_ACTION = 'BOARD_USER_ACTIVITY_TIMES_SET_ACTION';
